<template>
    <v-card
        class="dashboard-card ma-2"
        elevation="4"
    >
        <v-card-title>Management Claim Submissions</v-card-title>
        <v-card-subtitle>by days</v-card-subtitle>
        <v-card-subtitle>
            <v-select
                :disabled="dataObject == null"
                :items="users"
                @change="assignedUserChanged"
                clearable
                item-text="value"
                item-value="key"
                label="Assigned User"
                v-model="selectedUser"
            ></v-select>
        </v-card-subtitle>

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SUBMITTED WITH MISSING LINKS--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Submitted Missing Links</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                //agedDaysMinSubmission: -1,
                                agedDaysMaxSubmission: 30,                             
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                submittedMissingLink: true,
                                //submittedWithLink: true,
                                //shortPaid: true,
                                //fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinks.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinks.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinSubmission: 31,
                                agedDaysMaxSubmission: 60,                             
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                submittedMissingLink: true,
                                //submittedWithLink: true,
                                //shortPaid: true,
                                //fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinks.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinks.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinSubmission: 61,
                                agedDaysMaxSubmission: 90,                             
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                submittedMissingLink: true,
                                //submittedWithLink: true,
                                //shortPaid: true,
                                //fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinks.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinks.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinSubmission: 91,
                                agedDaysMaxSubmission: 120,                             
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                submittedMissingLink: true,
                                //submittedWithLink: true,
                                //shortPaid: true,
                                //fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinks.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinks.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinSubmission: 121,
                                //agedDaysMaxSubmission: -1,                             
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                submittedMissingLink: true,
                                //submittedWithLink: true,
                                //shortPaid: true,
                                //fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinks.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinks.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                //agedDaysMinSubmission: -1,
                                //agedDaysMaxSubmission: -1,                             
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                submittedMissingLink: true,
                                //submittedWithLink: true,
                                //shortPaid: true,
                                //fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedMissingLinks.group0_30+
                            dataObject.submittedMissingLinks.group31_60+
                            dataObject.submittedMissingLinks.group61_90+
                            dataObject.submittedMissingLinks.group91_120+
                            dataObject.submittedMissingLinks.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedMissingLinks.group0_30_Value+
                            dataObject.submittedMissingLinks.group31_60_Value+
                            dataObject.submittedMissingLinks.group61_90_Value+
                            dataObject.submittedMissingLinks.group91_120_Value+
                            dataObject.submittedMissingLinks.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SUBMITTED QUERIED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Submitted missing link - Queried</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMaxQueried: 30,
                                unresolvedQuery: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksQueried.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksQueried.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinQueried: 31,
                                agedDaysMaxQueried: 60,
                                unresolvedQuery: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksQueried.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksQueried.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinQueried: 61,
                                agedDaysMaxQueried: 90,
                                unresolvedQuery: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksQueried.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksQueried.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinQueried: 91,
                                agedDaysMaxQueried: 120,
                                unresolvedQuery: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksQueried.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksQueried.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinQueried: 121,
                                unresolvedQuery: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksQueried.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksQueried.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                unresolvedQuery: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedMissingLinksQueried.group0_30+
                            dataObject.submittedMissingLinksQueried.group31_60+
                            dataObject.submittedMissingLinksQueried.group61_90+
                            dataObject.submittedMissingLinksQueried.group91_120+
                            dataObject.submittedMissingLinksQueried.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedMissingLinksQueried.group0_30_Value+
                            dataObject.submittedMissingLinksQueried.group31_60_Value+
                            dataObject.submittedMissingLinksQueried.group61_90_Value+
                            dataObject.submittedMissingLinksQueried.group91_120_Value+
                            dataObject.submittedMissingLinksQueried.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SUBMITTED RE MISSING LINK--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Resubmitted missing link</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMaxSubmission: 30,
                                resubmittedMissingLink: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksRe.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksRe.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinSubmission: 31,
                                agedDaysMaxSubmission: 60,
                                resubmittedMissingLink: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksRe.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksRe.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinSubmission: 61,
                                agedDaysMaxSubmission: 90,
                                resubmittedMissingLink: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksRe.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksRe.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinSubmission: 91,
                                agedDaysMaxSubmission: 120,
                                resubmittedMissingLink: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksRe.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksRe.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinSubmission: 121,
                                resubmittedMissingLink: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedMissingLinksRe.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedMissingLinksRe.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                resubmittedMissingLink: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedMissingLinksRe.group0_30+
                            dataObject.submittedMissingLinksRe.group31_60+
                            dataObject.submittedMissingLinksRe.group61_90+
                            dataObject.submittedMissingLinksRe.group91_120+
                            dataObject.submittedMissingLinksRe.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedMissingLinksRe.group0_30_Value+
                            dataObject.submittedMissingLinksRe.group31_60_Value+
                            dataObject.submittedMissingLinksRe.group61_90_Value+
                            dataObject.submittedMissingLinksRe.group91_120_Value+
                            dataObject.submittedMissingLinksRe.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SUBMITTED WITH LINKS STATUS RD--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Submitted with links - RD/Registrations Registered not merited</h5>
            <h5 class="text--secondary">Registered not merited</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMaxStatusRD: 30,
                                submittedWithLink: true,
                                claimStatus: 1
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksRd.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksRd.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusRD: 31,
                                agedDaysMaxStatusRD: 60,
                                submittedWithLink: true,
                                claimStatus: 1
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksRd.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksRd.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusRD: 61,
                                agedDaysMaxStatusRD: 90,
                                submittedWithLink: true,
                                claimStatus: 1
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksRd.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksRd.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusRD: 91,
                                agedDaysMaxStatusRD: 120,
                                submittedWithLink: true,
                                claimStatus: 1
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksRd.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksRd.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusRD: 121,
                                submittedWithLink: true,
                                claimStatus: 1

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksRd.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksRd.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                submittedWithLink: true,
                                claimStatus: 1

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedAllLinksRd.group0_30+
                            dataObject.submittedAllLinksRd.group31_60+
                            dataObject.submittedAllLinksRd.group61_90+
                            dataObject.submittedAllLinksRd.group91_120+
                            dataObject.submittedAllLinksRd.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedAllLinksRd.group0_30_Value+
                            dataObject.submittedAllLinksRd.group31_60_Value+
                            dataObject.submittedAllLinksRd.group61_90_Value+
                            dataObject.submittedAllLinksRd.group91_120_Value+
                            dataObject.submittedAllLinksRd.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SUBMITTED WITH LINKS STATUS VV--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Submitted with links - VV/Merits</h5>
            <h5 class="text--secondary">Merited not bill reviewed</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMaxStatusVV: 30,
                                submittedWithLink: true,
                                claimStatus: 2
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksVv.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksVv.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusVV: 31,
                                agedDaysMaxStatusVV: 60,
                                submittedWithLink: true,
                                claimStatus: 2
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksVv.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksVv.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusVV: 61,
                                agedDaysMaxStatusVV: 90,
                                submittedWithLink: true,
                                claimStatus: 2
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksVv.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksVv.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusVV: 91,
                                agedDaysMaxStatusVV: 120,
                                submittedWithLink: true,
                                claimStatus: 2
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksVv.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksVv.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusVV: 121,
                                submittedWithLink: true,
                                claimStatus: 2

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksVv.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksVv.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                submittedWithLink: true,
                                claimStatus: 2

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedAllLinksVv.group0_30+
                            dataObject.submittedAllLinksVv.group31_60+
                            dataObject.submittedAllLinksVv.group61_90+
                            dataObject.submittedAllLinksVv.group91_120+
                            dataObject.submittedAllLinksVv.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedAllLinksVv.group0_30_Value+
                            dataObject.submittedAllLinksVv.group31_60_Value+
                            dataObject.submittedAllLinksVv.group61_90_Value+
                            dataObject.submittedAllLinksVv.group91_120_Value+
                            dataObject.submittedAllLinksVv.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SUBMITTED WITH LINKS STATUS O--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Submitted with links - O/Bill review</h5>
            <h5 class="text--secondary">Bill reviewed not on RNYP</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMaxStatusO: 30,
                                submittedWithLink: true,
                                claimStatus: 3
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksO.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksO.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusO: 31,
                                agedDaysMaxStatusO: 60,
                                submittedWithLink: true,
                                claimStatus: 3
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksO.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksO.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusO: 61,
                                agedDaysMaxStatusO: 90,
                                submittedWithLink: true,
                                claimStatus: 3
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksO.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksO.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusO: 91,
                                agedDaysMaxStatusO: 120,
                                submittedWithLink: true,
                                claimStatus: 3
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksO.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksO.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusO: 121,
                                submittedWithLink: true,
                                claimStatus: 3

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksO.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksO.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                submittedWithLink: true,
                                claimStatus: 3

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedAllLinksO.group0_30+
                            dataObject.submittedAllLinksO.group31_60+
                            dataObject.submittedAllLinksO.group61_90+
                            dataObject.submittedAllLinksO.group91_120+
                            dataObject.submittedAllLinksO.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedAllLinksO.group0_30_Value+
                            dataObject.submittedAllLinksO.group31_60_Value+
                            dataObject.submittedAllLinksO.group61_90_Value+
                            dataObject.submittedAllLinksO.group91_120_Value+
                            dataObject.submittedAllLinksO.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-CLAIMS SUBMITTED - OBJECTION--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Submitted - Objection</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMaxObjection: 30,
                                unresolvedObjection: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedObjection.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedObjection.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinObjection: 31,
                                agedDaysMaxObjection: 60,
                                unresolvedObjection: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedObjection.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedObjection.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinObjection: 61,
                                agedDaysMaxObjection: 90,
                                unresolvedObjection: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedObjection.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedObjection.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinObjection: 91,
                                agedDaysMaxObjection: 120,
                                unresolvedObjection: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedObjection.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedObjection.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinObjection: 121,
                                unresolvedObjection: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedObjection.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedObjection.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                unresolvedObjection: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedObjection.group0_30+
                            dataObject.submittedObjection.group31_60+
                            dataObject.submittedObjection.group61_90+
                            dataObject.submittedObjection.group91_120+
                            dataObject.submittedObjection.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedObjection.group0_30_Value+
                            dataObject.submittedObjection.group31_60_Value+
                            dataObject.submittedObjection.group61_90_Value+
                            dataObject.submittedObjection.group91_120_Value+
                            dataObject.submittedObjection.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-CLAIMS SUBMITTED - REJECTION--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Submitted - Repudiated</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMaxRejection: 30,
                                unresolvedRejection: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedRejection.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedRejection.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinRejection: 31,
                                agedDaysMaxRejection: 60,
                                unresolvedRejection: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedRejection.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedRejection.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinRejection: 61,
                                agedDaysMaxRejection: 90,
                                unresolvedRejection: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedRejection.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedRejection.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinRejection: 91,
                                agedDaysMaxRejection: 120,
                                unresolvedRejection: true,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedRejection.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedRejection.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinRejection: 121,
                                unresolvedRejection: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedRejection.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedRejection.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                unresolvedRejection: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedRejection.group0_30+
                            dataObject.submittedRejection.group31_60+
                            dataObject.submittedRejection.group61_90+
                            dataObject.submittedRejection.group91_120+
                            dataObject.submittedRejection.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedRejection.group0_30_Value+
                            dataObject.submittedRejection.group31_60_Value+
                            dataObject.submittedRejection.group61_90_Value+
                            dataObject.submittedRejection.group91_120_Value+
                            dataObject.submittedRejection.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-SUBMITTED WITH LINKS STATUS F--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">RNYP - F/Requested not yet paid</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMaxStatusF: 30,
                                submittedWithLink: true,
                                claimStatus: 4
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksF.group0_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksF.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusF: 31,
                                agedDaysMaxStatusF: 60,
                                submittedWithLink: true,
                                claimStatus: 4
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksF.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksF.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusF: 61,
                                agedDaysMaxStatusF: 90,
                                submittedWithLink: true,
                                claimStatus: 4
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">61-90</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksF.group61_90}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksF.group61_90_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusF: 91,
                                agedDaysMaxStatusF: 120,
                                submittedWithLink: true,
                                claimStatus: 4
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">91-120</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksF.group91_120}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksF.group91_120_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                agedDaysMinStatusF: 121,
                                submittedWithLink: true,
                                claimStatus: 4

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">121+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.submittedAllLinksF.group121_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.submittedAllLinksF.group121_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                submittedWithLink: true,
                                claimStatus: 4

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="blue-grey white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{
                            dataObject.submittedAllLinksF.group0_30+
                            dataObject.submittedAllLinksF.group31_60+
                            dataObject.submittedAllLinksF.group61_90+
                            dataObject.submittedAllLinksF.group91_120+
                            dataObject.submittedAllLinksF.group121_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            (
                            dataObject.submittedAllLinksF.group0_30_Value+
                            dataObject.submittedAllLinksF.group31_60_Value+
                            dataObject.submittedAllLinksF.group61_90_Value+
                            dataObject.submittedAllLinksF.group91_120_Value+
                            dataObject.submittedAllLinksF.group121_Plus_Value
                            ).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-PAID--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <!--
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Paid</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                //agedDaysMin: -1,
                                //agedDaysMax: -1,                                
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                //submittedMissingLink: true,
                                //submittedWithLink: true,
                                //shortPaid: true,
                                fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">In Full</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.paidInFull }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.paidInFull_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                //agedDaysMin: -1,
                                //agedDaysMax: -1,                                
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                //submittedMissingLink: true,
                                //submittedWithLink: true,
                                shortPaid: true,
                                //fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">Short</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.shortPaid }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.shortPaid_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
               <v-card
                    @click="
                        routerPush({
                            name: 'ClaimsPostSubmission',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                //agedDaysMin: -1,
                                //agedDaysMax: -1,                                
                                //acceptedNotSubmitted: true,
                                //unresolvedRejection: true,
                                //unresolvedObjection: true,
                                //submittedMissingLink: true,
                                //submittedWithLink: true,
                                isFinal: true,
                                //fullPaid: true,

                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">Final</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.isFinal }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.isFinal_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        -->
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-FOOTER--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <v-row justify="end">
                <v-col
                    align-self="center"
                    cols="12"
                    md="6"
                >
                    <h5
                        class="text--secondary"
                        style="text-align: right"
                    >
                        Auto updates every
                        {{ (refreshSeconds / 60000).toString().substr(0, 4) }} minutes
                        or
                        <v-btn
                            @click="getData"
                            class="ml-1 white--text"
                            color="secondary darken-1"
                            elevation="4"
                            fab
                            x-small
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </h5>
                </v-col>
            </v-row>
        </v-card-text>
        <!--#endregion-->
    </v-card>
</template>

<script>
export default {
    name: "ManagementClaimSubmissionWidget",
    props: {
        selectedAreaProviderFilter: {
            type: Object,
            default: () => {
                return { areaId: 0, providerId: 0 };
            }
        }
    },
    data: () => ({
        dataObject: null,
        refreshTimeout: null,
        refreshSeconds: 300000,
        storeDispatch: "claims/getclaimsubmissionmanagementwidgetdto",
        providerId: 0,
        areaId: 0,
        users: [],
        currentUserId: 0,
        selectedUser: null
        //
    }),
    mounted: async function() {
        this.users = await this.$store.dispatch("users/getlist");
        this.users.unshift({'key':null, 'value':"All"});
        this.currentUserId = await this.$store.dispatch("users/getCurrentUserId");
        this.selectedUser = this.currentUserId;
        this.refreshTimeout = setTimeout(this.getData, 0);
    },
    computed: {
        //
    },
    watch: {
        selectedAreaProviderFilter: function() {
            this.providerId = this.selectedAreaProviderFilter.providerId;
            this.areaId = this.selectedAreaProviderFilter.areaId;
            this.getData();
        }
    },
    methods: {
        assignedUserChanged() {
            this.refreshTimeout = setTimeout(this.getData, 0);    
        },
        routerPush(object) {
            if(this.selectedUser)
            object.params.assignedUserId = this.selectedUser
            this.$router.push(object);
        },
        getData() {
            this.stopRefreshTimeOut();
            this.dataObject = null;

            this.$store
                .dispatch(this.storeDispatch, {
                    urlParameters: {
                        providerId: this.selectedAreaProviderFilter.providerId,
                        areaId: this.selectedAreaProviderFilter.areaId,
                        assignedUserId: this.selectedUser
                    }
                })
                .then(dataResponse => {
                    this.dataObject = dataResponse;
                })
                .finally(() => {
                    this.refreshTimeout = setTimeout(
                        this.getData,
                        this.refreshSeconds
                    );
                });
        },
        stopRefreshTimeOut() {
            if (this.refreshTimeout != null) clearTimeout(this.refreshTimeout);
        }
        //--------------------
    },
    destroyed: function() {
        this.stopRefreshTimeOut();
    }
};
</script>

<style lang="stylus" scoped>
span {
    .facevalue {
        font-size: 0.54rem;
    }
}

#app.theme--light {
    span.facevalue {
        color: black !important;
    }
}

#app.theme--dark {
    span.facevalue {
        color: white !important;
    }
}
</style>